import React, { useState } from 'react'
import { useMutation } from '@apollo/react-hooks'
import SelectedRowsInList from './FileManagement/SelectedRowsInList'
import GET_SAVE_QUERY from './FileManagement/UpdateFile'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'


export default function SaveFileModal(props) {
  const [ saveFile ] = useMutation(
    GET_SAVE_QUERY
  )
  const [ saveMessage, setSaveMessage ] = useState('Do you want to save your changes?')
  const [ loading, setLoading ] = useState(false)

  const selectedRows = props.selectedRows.map(element => (
    {
      'cuid': element.cuid,
      'title':  element.title,
      'useForPreview': element.useForPreview,
      'key':  element.key
    }
  ))

  return (
    <Modal {...props} size='md' scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>Save Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            e.preventDefault()
            setSaveMessage('Your changes are being saved.')
            setLoading(true)
            saveFile(
              {
                variables: {
                  input: {
                    selectedRows: selectedRows
                  }
                }
              }
            ).then(() => {
              setSaveMessage('Do you want to save your changes?')
              setLoading(false)
              props.onClear()
              props.onHide()
            })
          }}
        >
          <p>{selectedRows.length>0 ? saveMessage : 'You have no new changes.'}</p>
          <div>
            <SelectedRowsInList selectedRows={props.selectedRows} loading={loading}></SelectedRowsInList>
          </div>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>Cancel</Button>
            <Button variant='primary' disabled={selectedRows.length<=0} type='submit'>Save Changes</Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

SaveFileModal.propTypes = {
  onHide: PropTypes.func,
  itemId: PropTypes.string,
  onClear: PropTypes.func,
  selectedRows: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
      map: PropTypes.func
    })
  ),
}
